/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentPackageAcceptTemplatesController(this: JS5Object, $routeParams: JS5Object, ContentEditService: JS5Object, EnumService: JS5Object,
                                                 $timeout: JS5Function, $location: JS5Object, $route: JS5Object) {


    /*
        Get the CPAT data
     */
    const getData = () => {
        this.loadingIndicator.show = true;
        this.editData = undefined;
        EnumService.queryForEnums().then(() => {
            return ContentEditService.getContentPackageAcceptTemplatesEditData($routeParams.id).then((editData: JS5Object) => {
                ContentEditService.originalPackageAcceptTemplateData = _.cloneDeep(editData);
                this.editData = editData;
                this.editorForm.$setPristine();
            });
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    /*
        Handler for Save toolbar button
     */
    const updateData = () => {
        this.loadingIndicator.show = true;
        prepareContentPackageAcceptTemplateContainersForUpdate();
        ContentEditService.updateContentPackageAcceptTemplates($routeParams.id, this.editData.contentPackageAcceptTemplateContainers).then((data: JS5Object) => {
            getData();
        });
    };


    /*
        Transforms members array and removes any CPAT Containers that have not been associated with members
     */
    const prepareContentPackageAcceptTemplateContainersForUpdate = () => {
        _.forEach(_.get(this, 'editData.contentPackageAcceptTemplateContainers'), (contentPackageAcceptTemplateContainer: JS5Object) => {
            _.set(contentPackageAcceptTemplateContainer, 'members', _.flatMap(_.get(contentPackageAcceptTemplateContainer, 'members')));
            _.unset(contentPackageAcceptTemplateContainer, 'packageAcceptTemplate.mediaAcceptProfiles');
            _.unset(contentPackageAcceptTemplateContainer, 'packageAcceptTemplate.type');
        });
        _.remove(_.get(this, 'editData.contentPackageAcceptTemplateContainers'), (contentPackageAcceptTemplateContainer: JS5Object) => {
            return _.isNil(_.get(contentPackageAcceptTemplateContainer, 'packageAcceptTemplate.id'));
        });
    };


    /*
        Handler for Revert toolbar button
     */
    const revertEditData = () => {
        this.editData = _.cloneDeep(ContentEditService.originalPackageAcceptTemplateData);
        this.editorForm.$setPristine();
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => this.editorForm && this.editorForm.$dirty,
            onClick: updateData
        },
        {
            label: 'Revert',
            enabled: () => this.editorForm && this.editorForm.$dirty,
            onClick: revertEditData
        },
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => {
                $location.url($route.current.rootRoute);
            }
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        getData();
    };

    this.$postLink = () => {
        $timeout(() => {
            ContentEditService.editorForm = this.editorForm;
        });
    };
}

angular.module('prism-ui.content').component('contentPackageAcceptTemplates', {
    templateUrl: 'meta/content/editor/components/view/packageAcceptTemplates/content-package-accept-templates-template.html',
    controller: ContentPackageAcceptTemplatesController,
    bindings: {}
});
